import * as Yup from 'yup';

const schema = Yup.object().shape({
  firstName: Yup.string().required('First Name is required.'),
  lastName: Yup.string().required('Last Name is required.'),
  email: Yup.string()
    .email('Enter a valid email address.')
    .required('Email is required.'),
  organization: Yup.string().required('Organization is required.'),
  organizationWebsite: Yup.string().required(
    'Organization Website is required.'
  ),
  phoneNumber: Yup.string().optional(),
  inquiryReason: Yup.string().required('Please select an inquiry reason.'),
  pointOfContactRole: Yup.string().when('inquiryReason', {
    is: (value: string) =>
      ['Teaming Opportunities', 'Partnership Inquiries'].includes(value),
    then: (schema) =>
      schema.required('Point of Contact Role/Title is required.'),
    otherwise: (schema) => schema.notRequired(),
  }),
  desiredCollaborationScope: Yup.string().optional(),
  clientProjectName: Yup.string().optional(),
  serviceDetails: Yup.string().optional(),
  typeOfCollaboration: Yup.string().when('inquiryReason', {
    is: 'Research Collaborations',
    then: (schema) => schema.required('Type of Collaboration is required.'),
    otherwise: (schema) => schema.notRequired(),
  }),
  relevantBackground: Yup.string().optional(),
  deadline: Yup.date().optional(),
  investmentInterestType: Yup.string().when('inquiryReason', {
    is: 'Investor Inquiries',
    then: (schema) => schema.required('Investment Interest Type is required.'),
    otherwise: (schema) => schema.notRequired(),
  }),
  programInterestType: Yup.string().when('inquiryReason', {
    is: 'EdTech Programs',
    then: (schema) => schema.required('Program Interest Type is required.'),
    otherwise: (schema) => schema.notRequired(),
  }),
  desiredProgramDates: Yup.date().optional(),
  numberOfParticipants: Yup.number().optional(),
  additionalProgramDetails: Yup.string().optional(),
  marketplaceType: Yup.string().when('inquiryReason', {
    is: 'Data Marketplace',
    then: (schema) => schema.required('Marketplace Type is required.'),
    otherwise: (schema) => schema.notRequired(),
  }),
  dataUseCase: Yup.string().optional(),
  specificDataset: Yup.string().optional(),
  preferredDeliveryFormat: Yup.string().optional(),
});

export default schema;
